import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const MediaImageList = t0 => {
  const $ = _c(8);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M21 7.6V20.4C21 20.7314 20.7314 21 20.4 21H7.6C7.26863 21 7 20.7314 7 20.4V7.6C7 7.26863 7.26863 7 7.6 7H20.4C20.7314 7 21 7.26863 21 7.6Z" strokeLinecap="round" strokeLinejoin="round" />;
    t2 = <path d="M18 4H4.6C4.26863 4 4 4.26863 4 4.6V18" strokeLinecap="round" strokeLinejoin="round" />;
    t3 = <path d="M7 16.8L12.4444 15L21 18" strokeLinecap="round" strokeLinejoin="round" />;
    t4 = <path d="M16.5 13C15.6716 13 15 12.3284 15 11.5C15 10.6716 15.6716 10 16.5 10C17.3284 10 18 10.6716 18 11.5C18 12.3284 17.3284 13 16.5 13Z" strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== props) {
    t5 = <IconWrapper {...props} variant="outline">{t1}{t2}{t3}{t4}</IconWrapper>;
    $[6] = props;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};
export { MediaImageList };